import {
  Component,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import Helper from 'src/app/core/utility/helper';
import { DataService } from 'src/app/services/data.service';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { SourceType } from 'src/app/models/sourcetype';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { ApprovedProposalPartInfo } from 'src/app/models/internal/approved-proposal-partinfo';
import UIHelper from '../../../core/utility/ui-helper';
import { QueryApprovedProposalDTO } from '../../../models/internal/query-approvedproposal-dto';
import { PackageType } from 'src/app/models/packagetype';
import { ActivatedRoute } from '@angular/router';
import { SearchFilterCondition } from '../../../models/internal/searchfiltercondition';
@Component({
  selector: 'app-approved-proposal-list',
  templateUrl: './approved-proposal-list.component.html',
  styleUrls: ['./approved-proposal-list.component.scss']
})
export class ApprovedProposalListComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData {
  excelFilenamePrefix = "ApprovedProposals_";
  IsForOpenAction: boolean = false;
  ApprovedProposalsForm: FormGroup;
  filterForm: FormGroup;
  sourceTypeList: SourceType[];
  partSystemList: PartSystemDTO[];
  packageTypeList: PackageType[];
  approvedProposalPartInfoList: ApprovedProposalPartInfo[];
  allItemsCheckBoxSelected: boolean = false;
  public formErrors = {
    itemsSelected: '',
  };
  constructor(private toastService: ToastService,
    private dataService: DataService,
    private fb: FormBuilder,
    private proposalService: ProposalService,
    localstorageService: LocalstorageService,
    private readonly route: ActivatedRoute,
    logger: NGXLogger,
    appSettings: AppSettings,
    public formService: FormService) {
    super(localstorageService, logger, appSettings);
    this.ApprovedProposalsForm = this.fb.group({
      itemsSelected: [null]
    });
    this.filterForm = this.fb.group({
      PartNumber: [null],
      SourceTypeId: [null],
      PartCategoryId: [null],
      PackageTypeId: [null]
    });
    this.route.queryParamMap.subscribe(params => {
      const openactionParam = params.get('openaction');
      console.log('openactionParam=' + openactionParam);
      if (openactionParam) {
        this.IsForOpenAction = true;
      }
  });
  }

  ngOnInit() {
    this.initFilterValues();
    this.getSourceTypes();
    this.getPartSystems();
    this.getPackageTypes();
    this.fillGrid();
  }

  exportData() {
    const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
    const queryApprovedProposalDTO: QueryApprovedProposalDTO = {
      SearchFilter: this.filter
    };
    this.dataService
      .getApprovedProposalsExcel(queryApprovedProposalDTO)
      .subscribe((response: any) => {
        if (response != null && response.Success) {
          UIHelper.DownloadExcelFile(response.Data, filename);
        } else {
          this.toastService.error(
            'Could not export data'
          );
        }
      });
  }

  getSourceTypes() {
    this.dataService.getParentSourceTypes().subscribe((response: any) => {
      if (response && response.Data != null) {
        this.sourceTypeList = response.Data;
      }
    });
  }

  getPartSystems() {
    this.dataService.getPartSystems().subscribe((response: any) => {
      if (response != null && response.Success) {
        this.partSystemList = response.Data;
      }
    });
  }

  getPackageTypes() {
    this.dataService.getPackageTypes().subscribe((response: any) => {
      if (response && response.Data != null) {
        this.packageTypeList = response.Data;
      }
    });
  }
 
  fillGrid(): void {
    this.filter.Skip = this.skip;
    this.filter.Take = this.pageSize;
    this.allItemsCheckBoxSelected = false;
    const queryApprovedProposalDTO: QueryApprovedProposalDTO = {
      SearchFilter: this.filter
    };
    this.getApprovedProposals(queryApprovedProposalDTO);
  }

  UpdateFilter() {
    this.filter.SearchFilterConditions = [];
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_LIKE);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
    this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
    
  }
 
  getWorkflowClass(workflowStatusId: any) : string {
    return 'workflow-' + workflowStatusId;
  }
  
  clearFilter() {
    this.filter.SearchFilterConditions = [];
    this.pageSize = this.filter.Take = 10;
    this.filterForm.reset();
    this.search();
    this.mainGrid = undefined;
  }

  initFilterValues(): void {
    this.filter = new SearchFilter();
  }

  viewProposal(id: number) {
    this.proposalService.RefreshproposalToViewId(id);
    window.open('viewproposal/' + id, '_blank');
  }

  formatDate(unformattedDate: Date) {
    return Helper.formatDate(unformattedDate);
  }

  /*
  TMS-17438 Fetch approved proposals from service call
  */
  getApprovedProposals(queryApprovedProposalDTO: QueryApprovedProposalDTO) {
    this.UpdateFilter();
    this.dataService
      .getApprovedProposals(queryApprovedProposalDTO)
      .subscribe((response: any) => {
        if (response != null) {
          this.approvedProposalPartInfoList = response.Data;
          this.gridView = of({
            data: response.Data,
            total: response.Total ? response.Total : 0,
          });
        }
      });
  }

  getPackageType(packageTypeId) {
    return Helper.getPackageTypeDescription(packageTypeId);
  }
}
